import styled from 'styled-components';
import { injectTypography } from '../../../utils/injectTypography';
export const StyledTitleBar = styled.div `
  display: grid;
  flex-shrink: 0;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  min-height: 64px;
  padding: var(${(props) => props.theme.responsive.spacing.xs});

  column-gap: var(${(props) => props.theme.responsive.spacing.l});

  background-color: ${(props) => props.theme.colors.utility.neutral[100]};
  border-bottom: 1px solid #333333;

  & > *:first-child {
    justify-self: start;
  }

  & > *:last-child {
    justify-self: end;
  }
`;
export const StyledCancelIcon = styled.svg ``;
export const StyledTitleBarButton = styled.button `
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  min-height: 48px;
  margin: 0;
  padding: var(${(props) => props.theme.responsive.spacing.s});

  color: ${(props) => props.theme.colors.utility.neutral[0]};

  background-color: transparent;
  border: none;

  cursor: pointer;

  appearance: none;

  ${(props) => injectTypography(props, 'copy2')}
`;
export const StyledTitle = styled.span `
  ${(props) => injectTypography(props, 'copy2')}

  color: ${(props) => props.theme.colors.utility.neutral[0]};
  font-weight: bold;
`;
//# sourceMappingURL=MobileOverlay.styles.js.map